import {MainApi} from "./MainApi";
import {OrganShareAllocateDTO, OrganShareDeallocateDTO, OrganShareSearchCondition} from "../types/organShare";
import {PageSearchCondition} from "../types/page";

export class OrganShareApi {
    static baseUrl = `${MainApi.urlPrefix}/organ-share`;

    static getOrganShareList = (dto: OrganShareSearchCondition) => () =>
        MainApi.api.get(`${OrganShareApi.baseUrl}${MainApi.toParamStringFromObject(dto)}`);

    static getSharedOrganList = (dto: PageSearchCondition) => () =>
        MainApi.api.get(`${OrganShareApi.baseUrl}/shared${MainApi.toParamStringFromObject(dto)}`);

    static getOrganManagerShareList = (dto: OrganShareSearchCondition) => () =>
        MainApi.api.get(`${OrganShareApi.baseUrl}/organ-manager${MainApi.toParamStringFromObject(dto)}`);

    static allocateAuthority = (dto: OrganShareAllocateDTO) => () =>
        MainApi.api.post(`${OrganShareApi.baseUrl}/allocate`, dto);

    static deallocateAuthority = (dto: OrganShareDeallocateDTO) => () =>
        MainApi.api.post(`${OrganShareApi.baseUrl}/deallocate`, dto);
}